import React, { useContext, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import Context from '../helper/context';
import { pageInfo } from './layout/navigation';

const Navbar = ({ compact, mobileOpen, onToggleCompact, onToggleMobile }) => {
  const history = useHistory(), location = useLocation();
  const context = useContext(Context);
  const name = context.userName || 'Minha conta';
  const initials = name.split(/\s+/).filter(Boolean).slice(0, 2).map(part => part[0]).join('').toUpperCase();
  const [leaving, setLeaving] = useState(false);
  const handleLogout = async () => {
    if (leaving) return;
    setLeaving(true);
    try { await context.handleUserLogout(); }
    catch { toast.info('Você saiu deste dispositivo. Não foi possível confirmar a revogação no servidor.'); }
    history.replace('/login/login-1');
  };
  return <header className="workspace-topbar">
    <button className="workspace-icon-button desktop-menu-toggle" type="button" aria-label={compact ? 'Expandir menu' : 'Recolher menu'} aria-expanded={!compact} aria-controls="workspace-navigation" onClick={onToggleCompact}><i className="mdi mdi-menu" aria-hidden="true" /></button>
    <button className="workspace-icon-button mobile-menu-toggle" type="button" aria-label={mobileOpen ? 'Fechar navegação' : 'Abrir navegação'} aria-expanded={mobileOpen} aria-controls="workspace-navigation" onClick={onToggleMobile}><i className="mdi mdi-menu" aria-hidden="true" /></button>
    <nav className="workspace-breadcrumb" aria-label="Localização"><span>Workspace</span><span aria-hidden="true">/</span><strong>{pageInfo(location.pathname).label}</strong></nav>
    <div className="workspace-account">
      <span className="workspace-session-label"><span />Sessão iniciada</span>
      <Dropdown alignRight>
        <Dropdown.Toggle className="workspace-account-toggle" variant="link" aria-label={`Conta de ${name}`}>
          <span className="workspace-avatar" aria-hidden="true">{initials}</span><span className="workspace-account-name"><strong>{name}</strong><small>Minha conta</small></span>
        </Dropdown.Toggle>
        <Dropdown.Menu><Dropdown.Header>{name}</Dropdown.Header><Dropdown.Divider /><Dropdown.Item as="button" disabled={leaving} onClick={handleLogout}><i className="mdi mdi-logout mr-2" aria-hidden="true" />{leaving ? 'Saindo…' : 'Sair da plataforma'}</Dropdown.Item></Dropdown.Menu>
      </Dropdown>
    </div>
  </header>;
};
export default Navbar;
